var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVi = function SvgIconVi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFC",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFDA44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.037 8.384a2.038 2.038 0 1 0-4.076 0H5.478c0 1.108.965 2.006 2.073 2.006h-.067c0 1.109.899 2.007 2.007 2.007 0 .981.705 1.797 1.635 1.971l-.005.012h1.756l-.005-.012a2.006 2.006 0 0 0 1.636-1.97 2.007 2.007 0 0 0 2.006-2.008h-.067c1.109 0 2.074-.898 2.074-2.006z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.104 14.173 9.84 17.026a5.7 5.7 0 0 0 2.16.421c.764 0 1.492-.15 2.159-.421l-1.264-2.853z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M9.392 9.386v3.51c0 1.997 2.608 2.609 2.608 2.609s2.609-.612 2.609-2.609v-3.51z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#338AF3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.91 12.085 1.411 3.946 1.396-3.946h1.066l-2.036 5.217h-.852l-2.05-5.217zM19.305 17.302v-5.217h1.014v5.217z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.435 10.52v4.254a4.6 4.6 0 0 0 1.043.561V10.52zM13.565 10.52v4.254a4.6 4.6 0 0 1-1.043.561V10.52z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M14.609 9.386H9.392v1.655h5.217z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconVi;